import React, { useContext } from "react";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import { CartContext } from "./CartContext";

function Shop() {
  const { addToCart } = useContext(CartContext);

  const handleAddToCart = (product) => {
    addToCart(
      product.id,
      1,
      product.size ? product.size[0] : "One size",
      product.colors ? product.colors[0] : "Default"
    );
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="shop">
      <div className="container">
        <h1 className="shop-title">All Products</h1>
        <div className="products-grid">
          {productData.map((product) => (
            <div key={product.id} className="product-card">
              <Link
                to={`/shopDetails/${product.id}`}
                className="product-link"
                onClick={toTop}
              >
                <div className="product-image-wrapper">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="product-image"
                  />
                </div>
                <div className="product-info">
                  <h3 className="product-name">{product.name}</h3>
                  <p className="product-price">${product.price}</p>
                </div>
              </Link>
              <button
                className="add-to-cart-btn"
                onClick={() => handleAddToCart(product)}
              >
                Add to cart
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Shop;
